import { request } from 'modules/request';

const validForPromo = (address, csrf) => {
  return request({
    url: '/api/v1/email-signup-promotion',
    method: 'POST',
    headers: {
      'X-CSRF-Token': csrf,
    },
    data: {
      data: {
        address,
      },
    },
  });
};

export default validForPromo;



/** WEBPACK FOOTER **
 ** ./apps/emailPromoModal/lib/validForPromoCheck.js
 **/